import { useEffect, useState } from "react";
import { FPaquetesStyle } from "./styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import TablaRegistro from "./TablaRegistro";
import useGetAPI from "../../../hooks/useGetAPI";
import AutoInputIATA from "./../AutoInputIATA";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { altaPaqueteVueloAction } from "./../../../ducks/paqueteDuck";
import { obtenerVuelosByIdPaqueteAction } from "./../../../ducks/vueloDuck";
import useCatalogos from "../../../hooks/useCatalogos";
import AltaVuelo from "./AltaVuelo";
import BackDrop from "./../../../global/BackDrop";
import HeaderModal from "./../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
const FPaquetesVuelos = (props) => {
  const { open = true, setOpen = () => { }, rowData = {} } = props;
  const dispatch = useDispatch();
  const classes = FPaquetesStyle();
  const catalogoIATA = useCatalogos("IATA");
  const [IdVuelo, setIdVuelo] = useState(0);
  const [proveedor, setProveedor] = useState("")
  const vuelosPaquete = useSelector((state) => state.vuelos.array);
  const [origen, setOrigen] = useState({ IdCodigo: 0 });
  const catVuelos = useGetAPI(`/Fligth/Destination/${origen.IdCodigo}`);
  const catProveedores = useGetAPI(`/Supplier/flight`);
  const [isLoad, setIsload] = useState(false);
  const [redondo, setRedondo] = useState(false);
  useEffect(() => {
    setIsload(true);
    dispatch(obtenerVuelosByIdPaqueteAction(rowData.IdPaquete)).then(
      (Response) => {
        setIsload(false);
      }
    );
  }, [dispatch, rowData.IdPaquete]);

  const onGuardar = () => {
    if (IdVuelo > 0) {
      if (proveedor) {
        let payload = {
          IdPaquete: rowData.IdPaquete,
          IdVuelo: IdVuelo,
          Redondo: (redondo) ? 1 : 0,
          ClaveProveedor: proveedor,
          ClavePaquete: rowData.ClavePaquete,
        };
        dispatch(altaPaqueteVueloAction(payload)).then((Response) => {
          switch (Response.status) {
            case 500:
              ToastMessage.fire({
                icon: "error",
                title: "Ha habido un problema de conexión con el servidor",
              });
              break;
            case 400:
              ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
              });
              break;
            default:
              LimpiarForm();
              dispatch(obtenerVuelosByIdPaqueteAction(rowData.IdPaquete));
              ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
              });
              break;
          }
        });
      }
    }
  };
  const LimpiarForm = () => {
    setIdVuelo(0);
    setProveedor("")
    setRedondo(false)
  };
  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
  };
  const handleSelecVuelo = (event) => {
    setIdVuelo(event.target.value);
  };
  const handleSelectProveedor = (event) => {
    setProveedor(event.target.value);
  }
  const handleChangeRedondo = () => {
    setRedondo(!redondo);
  };
  return (
    <ModalBase
      classes={classes}
      open={open}
      onClose={handleClose}
    >
      <HeaderModal titulo={`Vuelos para el paqute ${rowData.Nombre}`} handleClose={handleClose} />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={6}>
          <TablaRegistro rows={vuelosPaquete} idPaquete={rowData.IdPaquete} clavePaquete={rowData.ClavePaquete} />
        </Grid>
        <Grid item xs={6}>
          <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
              <AutoInputIATA
                label="Origen"
                name="origen"
                data={catalogoIATA}
                setTarget={setOrigen}
              />
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={10}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <InputLabel id="lTVuelo">Vuelo</InputLabel>
                  <Select
                    labelId="lTVuelo"
                    id="SVuelo"
                    name="vuelo"
                    value={IdVuelo}
                    onChange={handleSelecVuelo}
                    label="Vuelo"
                    disabled={origen.IdCodigo > 0 ? false : true}
                  >
                    <MenuItem value="0" disabled>
                      {"Seleccione una opción"}
                    </MenuItem>
                    {catVuelos.map((item, index) => (
                      <MenuItem key={item.IdVuelo} value={item.IdVuelo}>
                        {`${item.Destino.CodigoIATA} ${item.Destino.Descripcion}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <AltaVuelo origen={origen} IdPaquete={rowData.IdPaquete} ClavePaquete={rowData.ClavePaquete} />
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <InputLabel id="lTArerolina">Aerolinea</InputLabel>
                  <Select
                    labelId="lTArerolina"
                    id="sAerolinea"
                    name="aerolinea"
                    value={proveedor}
                    onChange={handleSelectProveedor}
                    label="Aerolinea"
                    disabled={origen.IdCodigo > 0 ? false : true}
                  >
                    <MenuItem value="" disabled>
                      {"Seleccione una opción"}
                    </MenuItem>
                    {catProveedores.map((item, index) => (
                      <MenuItem key={item.IdProveedor} value={item.Nombre}>
                        {`${item.Nombre} - ${item.RazonSocial}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                className={classes.formControl}
                control={
                  <Checkbox
                    checked={redondo}
                    onChange={handleChangeRedondo}
                    name="Redondo"
                    color="primary"
                  />
                }
                label="Redondo"
              />
            </Grid>
            <Grid item xs={12} className={classes.modalBotonesCenter}>
              <Button
                onClick={onGuardar}
                variant="contained"
                color="primary"
                disabled={IdVuelo > 0 && proveedor !== "" ? false : true}
                className={classes.modalBoton}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesVuelos;
